/**
 * TidbitSeparator - Separator dot component for tidbits
 * Displays a bullet point separator between player identity tidbits.
 * @remarks This is a simple presentation component
 */

import { memo } from "react";

import { Text } from "@/components/atoms/Text";

/** Props for TidbitSeparator */
interface TidbitSeparatorProps {
  readonly isDark: boolean;
}

/**
 * TidbitSeparator renders a bullet separator between tidbits
 * @param props - Props including theme state
 * @param props.isDark - Whether dark mode is enabled
 * @returns Text component with bullet character
 */
const TidbitSeparator = ({ isDark: _isDark }: TidbitSeparatorProps) => (
  <Text variant="body" className="text-content-muted">
    •
  </Text>
);

TidbitSeparator.displayName = "TidbitSeparator";

export default memo(TidbitSeparator);
